export default "__VITE_ASSET__C4FZ52Lp__"